import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpService } from 'src/app/services/http.service';
import { ShareDataService } from 'src/app/services/share-data.service';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';

import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip, Color } from 'ng2-charts';
import { isObject } from 'lodash';
declare var html2pdf: any;

@Component({
  selector: 'app-azure-step3',
  templateUrl: './azure-step3.component.html',
  styleUrls: ['./azure-step3.component.scss'],
})
export class AzureStep3Component implements OnInit {
  
  loading = false;
  Timeframe = 3;
  AWSRegins = 'US West (Oregon)';
  AzureRegins = 'eastus';
  GCPRegins = 'us-east1';
  hardwarecost: any;
  softwarecost: any;
  electricitycost: any;
  datacentercomputecost: any;
  datacenterstoragecost: any;
  networkingcost: any;
  storagehardwarecost: any;
  storagebackupcost: any;
  storagemaintenancecost: any;
  itlaborcost: any;
  servers: any;
  databases: any;
  storages: any;
  AllAWSRegins: any;
  AllAzureRegins: any;
  AllGCPRegins: any;
  newData: any = [];
  newResult: any = {};
  serverCost: any;
  storageCost: any
  networkCost: any;
  itLaborCost: any;

  totalHardwareCost = 0.0;
  totalSoftawareCost = 0.0;
  totalElectricitycost = 0.0;
  totalDatacentercomputecost = 0.0;
  totalstorageCost = 0.0;
  totalitlaborcost = 0.0;
  totalNetworkingcost = 0.0;
  totalCost = 0.0;
  totalSaveCostAWS = 0;
  totalSaveCostAzure = 0;
  totalSaveCostGCP = 0;
  resCount = 0;
  tempCount = 1;
  sectionCount = 1;

  awsData: any = {};
  azureData:any = {};
  gcpData:any = {};
  pdfSecondPageBreak:any = {
    server:false,
    storage:false,
    network:false,
    itlabour:false
  };
  customerData:any = {
    FirstName:"",
    LastName:"",
    PhoneNumber:"",
    Email:"",
    JobTitle:"",
    Company:"",
    About:""
  };


  public barChartOptions: ChartOptions = {
    responsive: true,
  };
  public barChartLabels: Label[] = ['On-Premisses', 'AWS'];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];

  public barChartData: ChartDataSets[] = [
  ];

  public pieChartOptions: ChartOptions = {
    responsive: true,
    plugins: {
      labels: {
        render: 'percentage',
        fontColor: ['green', 'blue', 'red', 'orange'],
        precision: 2
      }
    },
  };
  public pieChartLabels: Label[] = ['Hardware', 'Software', 'Overhead'];
  public awsPieChartLabels: Label[] = ['Hardware', 'Software', 'Overhead'];
  public azurePieChartLabels: Label[] = ['Hardware', 'Software', 'Overhead'];
  public gcpPieChartLabels: Label[] = ['Hardware', 'Software', 'Overhead'];
  public pieChartData: SingleDataSet = [300, 500, 100];
  public awsPieChartData: SingleDataSet = [300, 500, 100];
  public azurePieChartData: SingleDataSet = [300, 500, 100];
  public gcpPieChartData: SingleDataSet = [300, 500, 100];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];


  public lineChartData: ChartDataSets[] = [
    { fill: false, data: [], label: "On-premises" },
    { fill: false, data: [0, 500, 1000, 1500], label: "AWS" }
  ];
  public lineChartLabels: Label[] = [];
  public lineChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    scales : {
      yAxes: [{
          ticks: {
            beginAtZero: true,
            callback: function(value:any, index:any, values:any) {
              if(parseInt(value) >= 1000){
                return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return '$' + value;
              }
            }
          }
      }]
    },
    tooltips: {
      callbacks: {
          label: function(tooltipItem:any, data:any) {
              return data.datasets[tooltipItem.datasetIndex].label+": $" + Number(tooltipItem.yLabel).toFixed(0).replace(/./g, function(c, i, a) {
                  return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
              });
          }
      }
  }
  };
  public lineChartColors: Color[] = [
    {
      borderColor: "black",
      backgroundColor: "rgba(255,0,0,0.3)"
    }
  ];
  public lineChartLegend = true;
  public lineChartType: ChartType = "line";
  public lineChartPlugins = [];

  descriptiveCost: any = {
    computeCost: false,
    dataCenter: false,
    networkingCost: false,
    storageCost: false,
    itLabour: false,

    ServerHardwareCosts: false,
    RackInfrastructureCosts: false,
    FacilitiesCosts: false,
    NetworkAdminCost: false,
    ITLaborDatabaseAdminCost: false,
    Storage: false,
  }
  totalServerCost = 0.0;
  serverString: string = '';

  constructor(
    public shareDataService: ShareDataService,
    private httpService: HttpService,
    private spinner: NgxSpinnerService
  ) {
    this.AllAWSRegins = shareDataService.setep3.AWSRegins;
    this.AllAzureRegins = shareDataService.setep3.AzureRegins;
    this.AllGCPRegins = shareDataService.setep3.GCPRegins;
    // console.log(this.AllAzureRegins);
    monkeyPatchChartJsTooltip();
    monkeyPatchChartJsLegend();
    // console.log('\n\n=============================================================\n\n')
    // console.log(this.shareDataService.selectedServers)
    const selectedServers = _.union(_.filter(this.shareDataService.selectedServers, (item: any) => {
      return item !== 'none'
    }));
    this.serverString = (selectedServers[0] === 'aws') ? 'AWS' : (selectedServers[0] === 'gcp') ? 'GCP' : 'Azure';
    if (selectedServers.length == 2) {
      this.serverString = this.serverString + ' and ' + (selectedServers[1] === 'aws' ? 'AWS' : (selectedServers[1] === 'gcp') ? 'GCP' : 'Azure');
    }
    if (this.shareDataService.selectedServers[0] === this.shareDataService.selectedServers[1]) {
      this.shareDataService.selectedServers[1] = 'none'
    }
    
  }

  ngOnInit(): void {
    this.newDataFormat();
    window.scroll(0,0);
  }
  newDataFormat(): void {
    this.sectionCount = 1;
    if(this.shareDataService.selectedServers.includes('aws')) this.sectionCount++;
    if(this.shareDataService.selectedServers.includes('azure')) this.sectionCount++;
    if(this.shareDataService.selectedServers.includes('gcp')) this.sectionCount++;

    this.newData = [];
    this.lineChartData = [];
    _.forEach(this.shareDataService.setep1.servers, (item: any) => {
      item.NoOfProcs = this.shareDataService.Environment === 'Physical Server' ? Number(item.NoOfProcs) : 0;
      const size = _.find(this.shareDataService.setep2.dataCentCostAssumption, (data: any) => data.Procs === Number(item.NoOfProcs) && data.Cores === Number(item.NoOfCores));
      const power = _.find(this.shareDataService.setep2.electricityCostAssumption, (data: any) => data.Procs === Number(item.NoOfProcs) && data.Cores === Number(item.NoOfCores));
      const price = _.find(this.shareDataService.setep2.hardwareCostAssumption, (data: any) => data.Procs === Number(item.NoOfProcs) && data.Cores === Number(item.NoOfCores));
      this.newData.push({
        "ClusterName": item.name,
        "ServerCount": this.shareDataService.Environment === 'Physical Server' ? item.serversNumber : 0,
        "NoOfCores": this.shareDataService.Environment === 'Physical Server' ? Number(item.NoOfCores) : 0,
        "NoOfProcs": this.shareDataService.Environment === 'Physical Server' ? Number(item.NoOfProcs) : 0,
        "Ram": item.ram,
        "Utilization": (item.utilization * item.utilizationType).toFixed(0),
        "Size": size ? size.Size : 0,
        "Power": power ? power.Power : 0,
        "Price": price ? price.Price : 0,
        "DBEngine": "",
        "ServerType": "Non DB",
        "OperatingSystem": item.OS,
        "Environment": this.shareDataService.Environment,
        "VMServerCount": this.shareDataService.Environment === 'Physical Server' ? 0 : Number(item.NumberOfVms),
        "VMCore": this.shareDataService.Environment === 'Physical Server' ? 0 : Number(item.NoOfCores),
        "Hypervisor": this.shareDataService.Environment === 'Physical Server' ? "" : item.Hypervisor
      });
    });

    _.forEach(this.shareDataService.setep1.databases, (item: any) => {
      item.NoOfProcs = this.shareDataService.Environment === 'Physical Server' ? Number(item.NoOfProcs) : 0;
      const size = _.find(this.shareDataService.setep2.dataCentCostAssumption, (data: any) => data.Procs === Number(item.NoOfProcs) && data.Cores === Number(item.NoOfCores));
      const power = _.find(this.shareDataService.setep2.electricityCostAssumption, (data: any) => data.Procs === Number(item.NoOfProcs) && data.Cores === Number(item.NoOfCores));
      const price = _.find(this.shareDataService.setep2.hardwareCostAssumption, (data: any) => data.Procs === Number(item.NoOfProcs) && data.Cores === Number(item.NoOfCores));
      this.newData.push({
        "ClusterName": item.name,
        "ServerCount": this.shareDataService.Environment === 'Physical Server' ? item.serversNumber : 0,
        "NoOfCores": this.shareDataService.Environment === 'Physical Server' ? Number(item.NoOfCores) : 0,
        "NoOfProcs": this.shareDataService.Environment === 'Physical Server' ? Number(item.NoOfProcs) : 0,
        "Ram": item.ram,
        "Utilization": (item.utilization * item.utilizationType).toFixed(0),
        "Size": size ? size.Size : 0,
        "Power": power ? power.Power : 0,
        "Price": price ? price.Price : 0,
        "DBEngine": item.DBEngine,
        "ServerType": "DB",
        "OperatingSystem": item.OS,
        "Environment": this.shareDataService.Environment,
        "VMServerCount": this.shareDataService.Environment === 'Physical Server' ? 0 : Number(item.NumberOfVms),
        "VMCore": this.shareDataService.Environment === 'Physical Server' ? 0 : Number(item.NoOfCores),
        "Hypervisor": this.shareDataService.Environment === 'Physical Server' ? "" : item.Hypervisor
      });
    });

    const storage: any = [];
    _.forEach(this.shareDataService.setep1.storages, (item: any) => {
      storage.push({
        "StorageType": item.Storage,
        "RawStorageCapacity": item.Capacity/item.capacityType,
        "AccessedInfrequently": item.Storage === "Object" ? item.Accessibility : 0,
        "DiskType": item.DiskType,
        "MaxIOPS": item.MaxIops,
        "BackupPercentagePerMonthPer": 0
      });
    });
    this.shareDataService.setep2.Currency
    const data = {
      "Currency": _.find(this.shareDataService.currencies, ['ID', this.shareDataService.setep2.Currency]).CurrencyCode,
      "AwsRegion": this.AWSRegins,
      "Timeframe": this.Timeframe,
      "SqlServerStandardSACost": _.find(this.shareDataService.setep2.SoftwareCostAssumption, (item: any) => item.ID === 1).Value,
      "SqlServerEnterpriseSACost": _.find(this.shareDataService.setep2.SoftwareCostAssumption, (item: any) => item.ID === 2). Value,
      "ServersData": this.newData,
      "StorageData": storage,
      // "TotalDbSoftwareCost":431820,
      // "VirtualSoftwareTotalSACost":0,
      // "ServerSoftwareTotalSACost":1125,
      // "AvgDataTransOutbound":10.3,
      // "UsableCapacityBasedonRAIDConfiguration":737.28,
      // "TotalStorageCost":129089,
    };
    this.spinner.show();
    this.resCount = 0;
    this.tempCount = 1;
    this.lineChartData.push({fill: false, data: [], label: "On-premises"});
    if(this.shareDataService.selectedServers.includes("azure")){
      this.tempCount++;
      this.lineChartData.push({ fill: false, data: [0, 500, 1000, 1500], label: "Azure" });
    }
    if(this.shareDataService.selectedServers.includes("aws")){
      this.tempCount++;
      this.lineChartData.push({ fill: false, data: [0, 500, 1000, 1500], label: "AWS" });
    }
    if(this.shareDataService.selectedServers.includes("gcp")){
      this.tempCount++;
      this.lineChartData.push({ fill: false, data: [0, 500, 1000, 1500], label: "GCP" });
    }
    console.log(data);
    this.httpService.post('prod/onpremisescost', data).subscribe((res: any) => {
      // console.log(JSON.stringify(res))
      // this.getAwsData(data, res);
      // console.log('\n\n\n===========================================================================\n')
      // console.log(res)
      this.newResult = {};
      this.newResult = res;
      this.resCount++;
      
      // this.serverCost = {
      //   ServerCostBreakDown: res.ServerCostBreakDown
      // }

      // this.networkCost = {
      //   NetworkHardwareAndSoftwareCost: this.newResult.NetworkHardwareAndSoftwareCost,
      //   OnPremisesBandwidthCost: this.newData.OnPremisesBandwidthCost,
      //   NetworkAdminCost: this.newResult.NetworkAdminCost
      // }

      // this.itlaborcost = {
      //   ITLaborDatabaseAdminCost: this.newResult.ITLaborDatabaseAdminCost,
      //   ITLaborNonDatabaseAdminCost: this.newResult.ITLaborNonDatabaseAdminCost,
      //   ITLaborTotalCost: this.newResult.ITLaborTotalCost
      // }

      this.totalServerCost = res.TotalServerCost[0] ? res.TotalServerCost[0].Value : 0;
      this.totalNetworkingcost = res.TotalNetworkCost[0] ? res.TotalNetworkCost[0].Value : 0;
      this.totalstorageCost = res.TotalStorageCost[0] ? res.TotalStorageCost[0].Value : 0;
      this.totalitlaborcost = res.ITLaborTotalCost[0] ? res.ITLaborTotalCost[0].Value : 0;
      //this.totalCost = this.totalServerCost + this.totalNetworkingcost + this.totalstorageCost + this.totalitlaborcost;
      this.totalCost = this.totalServerCost + this.totalNetworkingcost + this.totalstorageCost;
      this.totalCost = Number(this.totalCost.toFixed(0));
      this.totalServerCost = Number(this.totalServerCost.toFixed(0))
      this.totalNetworkingcost = Number(this.totalNetworkingcost.toFixed(0))
      this.totalstorageCost = Number(this.totalstorageCost.toFixed(0))
      this.totalitlaborcost = Number(this.totalitlaborcost.toFixed(0))
      this.barChartData = [
        { barThickness: 75, data: [this.totalServerCost, this.totalServerCost-((30*this.totalServerCost)/100)], label: 'Server', stack: 'a' },
        { barThickness: 75, data: [this.totalstorageCost, this.totalstorageCost-((30*this.totalstorageCost)/100)], label: 'Storage', stack: 'a' },
        { barThickness: 75, data: [this.totalNetworkingcost, this.totalNetworkingcost-((30*this.totalNetworkingcost)/100)], label: 'Network', stack: 'a' },
       // { barThickness: 75, data: [this.totalitlaborcost, this.totalitlaborcost-((30*this.totalitlaborcost)/100)], label: 'IT Labor', stack: 'a' },
      ];
      for(let _i = 0; this.lineChartData.length > _i; _i++){
        this.lineChartData[_i].data = [];
      }
      
      // this.lineChartLabels = []

      // const cost_per_year = this.totalCost/this.Timeframe;
      // const aws_cost_per_year = ((30*this.totalCost)/100)/this.Timeframe;
      // this.totalSaveCost = this.totalCost - ((30*this.totalCost)/100);
      // for(let x = 0; x <= this.Timeframe; x++) {
      //   this.lineChartData[0].data?.push(cost_per_year*x);
      //   this.lineChartData[1].data?.push(aws_cost_per_year*x);
      //   if (x === 0) {
      //     this.lineChartLabels.push('0');
      //   } else {
      //     this.lineChartLabels.push(`${x} Year`);
      //   }
      // }
      if(this.shareDataService.selectedServers.includes("aws")){
        data["AwsRegion"] = this.AWSRegins;
        this.getAwsData(data, res);
      }
      if(this.shareDataService.selectedServers.includes("azure")){
        data["AwsRegion"] = this.AzureRegins;
        this.getAzureData(data,res);
      }
      if(this.shareDataService.selectedServers.includes("gcp")){
        data["AwsRegion"] = this.GCPRegins;
        this.getGCPData(data,res);
      }
      // this.lineChartData[0].data = [0, this.totalServerCost/3, this.totalServerCost/2, this.totalServerCost ]
      this.calculateServerCost();
      this.calculateNetworkCost();
      this.calculateITLaborCost();
    });
  }

  lineChartDataFormat(): void {
    this.lineChartLabels = [];
    const cost_per_year = this.totalCost/this.Timeframe;
    var aws_cost_per_year = 0;
    var azure_cost_per_year = 0;
    var gcp_cost_per_year = 0;
    if(this.shareDataService.selectedServers.includes("aws")){
      aws_cost_per_year = this.awsData['totalCost']/this.Timeframe;
      this.totalSaveCostAWS = this.totalCost - this.awsData['totalCost'];
      }
    if(this.shareDataService.selectedServers.includes("azure")){
      azure_cost_per_year = this.azureData['totalCost']/this.Timeframe;;
      this.totalSaveCostAzure = this.totalCost - this.azureData['totalCost'];
    }
    if(this.shareDataService.selectedServers.includes("gcp")){
      gcp_cost_per_year = this.gcpData['totalCost']/this.Timeframe;;
      this.totalSaveCostGCP = this.totalCost - this.gcpData['totalCost'];
    }

    for(let x = 0; x <= this.Timeframe; x++) {

      this.lineChartData[this.findIndexInLineChart("On-premises")].data?.push(Number((cost_per_year*x).toFixed(0)));
      if(this.shareDataService.selectedServers.includes("aws")){
      this.lineChartData[this.findIndexInLineChart("AWS")].data?.push(Number((aws_cost_per_year*x).toFixed(0)));
      }
      if(this.shareDataService.selectedServers.includes("azure")){
        this.lineChartData[this.findIndexInLineChart("Azure")].data?.push(Number((azure_cost_per_year*x).toFixed(0)));
      }
      if(this.shareDataService.selectedServers.includes("gcp")){
        this.lineChartData[this.findIndexInLineChart("GCP")].data?.push(Number((gcp_cost_per_year*x).toFixed(0)));
      }
      
      if (x === 0) {
        this.lineChartLabels.push('0');
      } else {
        this.lineChartLabels.push(`${x} Year`);
      }
    }
    // console.log("data:\n");
    // console.log(this.lineChartData);
  }

  findIndexInLineChart(input:string): number{
    var result = -1;
   
    for(var _i = 0; _i < this.lineChartData.length; _i++){
      if(this.lineChartData[_i].label == input){
        result = _i;
        break;
      }
    }

    return result;
  }

  getAzureData(data: any, res: any): void {
    // console.log(this.shareDataService.setep2.itlaborcosts);
    data ['TotalDbSoftwareCost'] = res.TotalDBSoftwareLicenseCost[0].Value;
    data ['VirtualSoftwareTotalSACost'] = res.GuestOSLicense[3] ? res.GuestOSLicense[3].Value : 0;
    data ['ServerSoftwareTotalSACost'] = res.ServerSoftwareCost[3] ? res.ServerSoftwareCost[3].Value : 0;
    data ['AvgDataTransOutbound'] = res.OnPremisesBandwidthCost[7].Value;
    data ['TransactionId'] = res.TransactionId;
    let itHourCost = 13;
    for(let item of this.shareDataService.setep2.itlaborcosts){
      if(item.Description == "Hourly rate for IT administrator"){
        itHourCost = item.Value;
        break;
      }
    }
    data ['ITAdministratorHourlyRate'] = itHourCost;
    //console.log(data);
    this.httpService.post('prod/azurecost', data).subscribe((res: any) => {
      // console.log('\n\n\n--------------------------------------------------------------\n\n')
      // console.log(res)
      this.azureData = res;
      this.azureData['totalServerCost'] =  res.TotalAzureComputeCost.length > 0 ? Number(res.TotalAzureComputeCost[0].Value.toFixed(0)) :  0;
      this.azureData['totalNetworkingcost'] = Number(res.TotalNetworkCost[0].Value.toFixed(0));
      this.azureData['totalstorageCost'] = Number(res.TotalStorageCost[0].Value.toFixed(0));
      this.azureData['totalitlaborcost'] = Number(res.TotalITLaborCost[0].Value.toFixed(0));
      //this.azureData['totalCost'] = Number((res.TotalITLaborCost[0].Value + (res.TotalAzureComputeCost.length > 0 ? Number(res.TotalAzureComputeCost[0].Value) : 0) + res.TotalNetworkCost[0].Value + res.TotalStorageCost[0].Value).toFixed(0));
      this.azureData['totalCost'] = Number(((res.TotalAzureComputeCost.length > 0 ? Number(res.TotalAzureComputeCost[0].Value) : 0) + res.TotalNetworkCost[0].Value + res.TotalStorageCost[0].Value).toFixed(0));
      this.resCount++;
      if(this.tempCount == this.resCount){
        this.resCount = 0;
      this.lineChartDataFormat();
      this.pieChartDataFormat();
      this.spinner.hide();
      }
    });

  }

  getGCPData(data: any, res: any): void {
    data ['TotalDbSoftwareCost'] = res.TotalDBSoftwareLicenseCost[0].Value;
    data ['VirtualSoftwareTotalSACost'] = res.GuestOSLicense[3] ? res.GuestOSLicense[3].Value : 0;
    data ['ServerSoftwareTotalSACost'] = res.ServerSoftwareCost[3] ? res.ServerSoftwareCost[3].Value : 0;
    data ['AvgDataTransOutbound'] = res.OnPremisesBandwidthCost[7].Value;
    data ['TransactionId'] = res.TransactionId;
    //console.log("test:");
    //console.log(data);
    this.httpService.post('prod/gcpcost', data).subscribe((res: any) => {
      // console.log('\n\n\n--------------------------------------------------------------\n\n')
      //debugger;
      // console.log(res)
      this.gcpData = res;
      this.gcpData['totalServerCost'] =  (res.TotalGCPComputeCost.length > 0 ? Number(res.TotalGCPComputeCost[0].Value.toFixed(0)) : 0);
      this.gcpData['totalNetworkingcost'] = (res.TotalNetworkCost.length > 0 ? Number(res.TotalNetworkCost[0].Value.toFixed(0)) : 0);
      this.gcpData['totalstorageCost'] = Number(res.TotalGCPStorageCost[0].Value.toFixed(0));
      this.gcpData['totalitlaborcost'] = Number(0);
      this.gcpData['totalCost'] = Number((this.gcpData['totalServerCost'] + this.gcpData['totalNetworkingcost'] + this.gcpData['totalstorageCost'] + this.gcpData['totalitlaborcost']).toFixed(0));
      this.resCount++;
      if(this.tempCount == this.resCount){
        this.resCount = 0;
      this.lineChartDataFormat();
      this.pieChartDataFormat();
      this.spinner.hide();
      }
    });

  }

  getAwsData(data: any, res: any): void {

    data ['TotalDbSoftwareCost'] = res.TotalDBSoftwareLicenseCost[0].Value;
    data ['VirtualSoftwareTotalSACost'] = res.GuestOSLicense[3] ? res.GuestOSLicense[3].Value : 0;
    data ['ServerSoftwareTotalSACost'] = res.ServerSoftwareCost[3] ? res.ServerSoftwareCost[3].Value : 0;
    data ['AvgDataTransOutbound'] = res.OnPremisesBandwidthCost[7].Value;
    data ['UsableCapacityBasedonRAIDConfiguration'] = res.StorageObjectCost && res.StorageObjectCost[3] ? res.StorageObjectCost[3].Value : 0;
    data ['TotalStorageCost'] = res.TotalStorageCost[0].Value;
    data ['TransactionId'] = res.TransactionId;
   // console.log(JSON.stringify(data))
    let apiString="prod/awsonpremisescost";
    // if(data && data.ServersData && data.ServersData.length > 0){
    //   let osType = data.ServersData[0].OperatingSystem;
    //   if(osType.indexOf("LI") > 0){
    //     apiString="prod/awsonpremisescostli";
    //   }
    // }

    this.httpService.post(apiString, data).subscribe((res: any) => {
      // console.log('\n\n\n--------------------------------------------------------------\n\n');
      // console.log(res);
      this.awsData = {};
      this.awsData = res;
      this.awsData['totalServerCost'] = Number(res.TotalServerCost[0].Value.toFixed(0));
      this.awsData['totalNetworkingcost'] = Number(res.TotalNetworkCost[0].Value.toFixed(0));
      this.awsData['totalstorageCost'] = Number(res.TotalStorageCost[0].Value.toFixed(0));
      this.awsData['totalitlaborcost'] = Number(res.TotalITLaborCost[0].Value.toFixed(0));
      //this.awsData['totalCost'] = Number((res.TotalITLaborCost[0].Value + res.TotalServerCost[0].Value + res.TotalNetworkCost[0].Value + res.TotalStorageCost[0].Value).toFixed(0));
      this.awsData['totalCost'] = Number((res.TotalServerCost[0].Value + res.TotalNetworkCost[0].Value + res.TotalStorageCost[0].Value).toFixed(0));
      this.resCount++;
      if(this.tempCount == this.resCount){
        this.resCount = 0;
      this.lineChartDataFormat();
      this.pieChartDataFormat();
      this.spinner.hide();
      }
      
    });
  }

  calculateServerCost(): void {
    this.serverCost = {
      totalServers: _.sum(_.map(this.newResult.ServerHardwareCostsTableData, (item) => {return Number(item[0].Value)})),
      totalUnit: _.sum(_.map(this.newResult.ServerHardwareCostsTableData, (item) => {return Number(item[3].Value)})),
      totalPowser: Number(_.sum(_.map(this.newResult.ServerHardwareCostsTableData, (item) => {return Number(item[4].Value)})).toFixed(2)),
      totalCost: Number(_.sum(_.map(this.newResult.ServerHardwareCostsTableData, (item) => {return Number(item[7].Value)})).toFixed(0))
    }
    // totalserverTableData = this.newResult.ServerHardwareCostsTableData
    // this.serverCost = {
    //   ServerHardwareCostsTableData: this.newResult.ServerHardwareCostsTableData,
    //   totalserverTableData: 
    // }
  }

  pieChartDataFormat(): void{
    // pie chart data formating
    //this.pieChartLabels = [' Server ', ' Storage ', ' Network ', ' IT Labor '];
    this.pieChartLabels = [' Server ', ' Storage ', ' Network '];
    this.pieChartLabels[0] = this.pieChartLabels[0] + ((this.totalServerCost*100)/this.totalCost).toFixed(2) + ' %';
    this.pieChartLabels[1] = this.pieChartLabels[1] + ((this.totalstorageCost*100)/this.totalCost).toFixed(2) + ' %';
    this.pieChartLabels[2] = this.pieChartLabels[2] + ((this.totalNetworkingcost*100)/this.totalCost).toFixed(2) + ' %';
    //this.pieChartLabels[3] = this.pieChartLabels[3] + ((this.totalitlaborcost*100)/this.totalCost).toFixed(2) + ' %';
    //this.pieChartData = [this.totalServerCost, this.totalstorageCost, this.totalNetworkingcost, this.totalitlaborcost];
    this.pieChartData = [this.totalServerCost, this.totalstorageCost, this.totalNetworkingcost];

    if(this.shareDataService.selectedServers.includes("aws")){
    //this.awsPieChartLabels = [' Server ', ' Storage ', ' Network ', ' IT Labor '];
    this.awsPieChartLabels = [' Server ', ' Storage ', ' Network '];
    this.awsPieChartLabels[0] = this.awsPieChartLabels[0] + ((this.awsData.totalServerCost*100)/this.awsData.totalCost).toFixed(2) + ' %';
    this.awsPieChartLabels[1] = this.awsPieChartLabels[1] + ((this.awsData.totalstorageCost*100)/this.awsData.totalCost).toFixed(2) + ' %';
    this.awsPieChartLabels[2] = this.awsPieChartLabels[2] + ((this.awsData.totalNetworkingcost*100)/this.awsData.totalCost).toFixed(2) + ' %';
    //this.awsPieChartLabels[3] = this.awsPieChartLabels[3] + ((this.awsData.totalitlaborcost*100)/this.awsData.totalCost).toFixed(2) + ' %';
    //this.awsPieChartData = [this.awsData.totalServerCost, this.awsData.totalstorageCost, this.awsData.totalNetworkingcost, this.awsData.totalitlaborcost];
    this.awsPieChartData = [this.awsData.totalServerCost, this.awsData.totalstorageCost, this.awsData.totalNetworkingcost];
    }

    if(this.shareDataService.selectedServers.includes("azure")){
    //this.azurePieChartLabels = [' Server ', ' Storage ', ' Network ', ' IT Labor '];
    this.azurePieChartLabels = [' Server ', ' Storage ', ' Network '];
    this.azurePieChartLabels[0] = this.azurePieChartLabels[0] + ((this.azureData.totalServerCost*100)/this.azureData.totalCost).toFixed(2) + ' %';
    this.azurePieChartLabels[1] = this.azurePieChartLabels[1] + ((this.azureData.totalstorageCost*100)/this.azureData.totalCost).toFixed(2) + ' %';
    this.azurePieChartLabels[2] = this.azurePieChartLabels[2] + ((this.azureData.totalNetworkingcost*100)/this.azureData.totalCost).toFixed(2) + ' %';
    //this.azurePieChartLabels[3] = this.azurePieChartLabels[3] + ((this.azureData.totalitlaborcost*100)/this.azureData.totalCost).toFixed(2) + ' %';
    //this.azurePieChartData = [this.azureData.totalServerCost, this.azureData.totalstorageCost, this.azureData.totalNetworkingcost, this.azureData.totalitlaborcost];
    this.azurePieChartData = [this.azureData.totalServerCost, this.azureData.totalstorageCost, this.azureData.totalNetworkingcost];
    }

    if(this.shareDataService.selectedServers.includes("gcp")){
      //this.gcpPieChartLabels = [' Server ', ' Storage ', ' Network ', ' IT Labor '];
      this.gcpPieChartLabels = [' Server ', ' Storage ', ' Network '];
      this.gcpPieChartLabels[0] = this.gcpPieChartLabels[0] + ((this.gcpData.totalServerCost*100)/this.gcpData.totalCost).toFixed(2) + ' %';
      this.gcpPieChartLabels[1] = this.gcpPieChartLabels[1] + ((this.gcpData.totalstorageCost*100)/this.gcpData.totalCost).toFixed(2) + ' %';
      this.gcpPieChartLabels[2] = this.gcpPieChartLabels[2] + ((this.gcpData.totalNetworkingcost*100)/this.gcpData.totalCost).toFixed(2) + ' %';
      //this.gcpPieChartLabels[3] = this.gcpPieChartLabels[3] + ((this.gcpData.totalitlaborcost*100)/this.gcpData.totalCost).toFixed(2) + ' %';
      //this.gcpPieChartData = [this.gcpData.totalServerCost, this.gcpData.totalstorageCost, this.gcpData.totalNetworkingcost, this.gcpData.totalitlaborcost];
      this.gcpPieChartData = [this.gcpData.totalServerCost, this.gcpData.totalstorageCost, this.gcpData.totalNetworkingcost];
      }
  }

  calculateNetworkCost(): void {
    
  }

  calculateITLaborCost(): void {
    
  }

  onSTOToggleClick(type: any): void {
    this.descriptiveCost[type] = !this.descriptiveCost[type];
  }

  onToggleClick(index: any): void {
    
  }

  onTimeFrameChange(event: any): void {
    this.Timeframe = Number(event.target.value);
    this.newDataFormat()
  }

  onAWSRegionChange(event: any): void {
    this.AWSRegins = event.target.value;
    this.newDataFormat()
  }

  onAzureRegionChange(event: any): void {
    this.AzureRegins = event.target.value;
    this.newDataFormat()
  }

  onGCPRegionChange(event: any): void {
    this.GCPRegins = event.target.value;
    this.newDataFormat()
  }

  calculation(): any {
    // console.log('\n\n=========================================================================================\n\n')
    // console.log(this.hardwarecost);
    // console.log(this.softwarecost);
    // console.log(this.electricitycost);
    // console.log(this.datacentercomputecost);
    // console.log(this.datacenterstoragecost);
    // console.log(this.networkingcost);
    // console.log(this.storagehardwarecost);
    // console.log(this.storagebackupcost);
    // console.log(this.storagemaintenancecost);
    // console.log(this.itlaborcost);
    // console.log('\n\n-------------------------------------------------------------------------------\n\n')
    // if (
    //   this.hardwarecost &&
    //   this.softwarecost &&
    //   this.electricitycost &&
    //   this.datacentercomputecost &&
    //   this.datacenterstoragecost &&
    //   this.networkingcost &&
    //   this.storagehardwarecost &&
    //   this.storagebackupcost &&
    //   this.storagemaintenancecost
    // ) {
    //   console.log('\n\n=========================================================================================\n\n')
    //   console.log(this.hardwarecost);
    //   console.log(this.softwarecost);
    //   console.log(this.electricitycost);
    //   console.log(this.datacentercomputecost);
    //   console.log(this.datacenterstoragecost);
    //   console.log(this.networkingcost);
    //   console.log(this.storagehardwarecost);
    //   console.log(this.storagebackupcost);
    //   console.log(this.storagemaintenancecost);
    //   console.log(this.itlaborcost);
    //   console.log('\n\n-------------------------------------------------------------------------------\n\n')
    // }
  }

  back(): any{
    this.shareDataService.step = 2;
  }

  sendUserDetails(){
    this.shareDataService.setep3.IsUserDataProvied = true;
    let model = document.querySelector(".close[data-dismiss=modal]");
    if(model) {(model as HTMLElement).click();}

    this.httpService.post('prod/savecustomerdetails', this.customerData).subscribe((res: any) => {
      //console.log(res);
      if(res && res?.responseCode && res?.responseCode == "SUCCESS"){
        this.pdfReport();
      }
    });
    
  }

  getMaxHeightInPDFCal(id:string):number{
    id += " div.p-border-box.p-serverHardwareCosts";
    let ele = document.querySelectorAll(id);
    let max = 0;
    for(let i = 0; i < ele.length; i++){
      if(ele[0].clientHeight > max) max =  ele[0].clientHeight;

    }
    return max;
  }

  pdfReport(): any{
  this.spinner.show();
  let tables =  document.getElementById("pdf");


  
  var opt = {
    margin:       [60, 0.01, 20, 0.01],
    filename:     'AssessmentReport.pdf',
    image:        { type: 'jpeg', quality: 0.98 },
    html2canvas:  { scale: 2 ,scrollX: 0, scrollY: 0},
    jsPDF:        { unit: 'pt', format: 'a4' , orientation: this.sectionCount > 3 ? 'l': 'p' },
    pagebreak: { mode:'css'}
  };
  console.log("pdf init");
  if(tables) tables.style.display = "block";
  // New Promise-based usage:
    
  this.pdfSecondPageBreak.server = this.getMaxHeightInPDFCal("#pdfServer") > 850;
  this.pdfSecondPageBreak.server = this.getMaxHeightInPDFCal("#pdfStorage") > 850;
  this.pdfSecondPageBreak.server = this.getMaxHeightInPDFCal("#pdfNetwork") > 850;

  setTimeout(() => {
    html2pdf().from(tables).set(opt).toPdf().get('pdf').then((pdf:any) => {
      var totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(10);
          pdf.setTextColor(150);
          let img = document.getElementById("logo");
          pdf.addImage(img, 'PNG', 20 , 15, 228, 40);
          pdf.text('Page ' + i + ' of ' + totalPages, pdf.internal.pageSize.getWidth() - 100, pdf.internal.pageSize.getHeight() - 10);
          
        }
        if(tables) tables.style.display = "none";
        this.spinner.hide();
    }).save();
  }, 2000);
  
  }
  
}
